'use client';

import ToolTip from 'components/tooltip';
import IconButton from 'components/controls/buttons/icon-button';
import ShareIcon from 'assets/icons/share.svg';
import MailSVG from 'assets/icons/mail.svg';
import XSVG from 'assets/icons/social/x.svg';
import PintrestSVG from 'assets/icons/social/pintrest.svg';
import FacebookSVG from 'assets/icons/social/facebook.svg';
import styles from './styles.module.scss';

const objectPagePathBase = `https://www.metmuseum.org/art/collection/search`; // TODO: someone move this to routes package
export const ShareLinks = ({ objectID, thumbnail, title }: IProps) => {
	return (
		<ul className={styles.socialItems}>
			{[
				{
					title: 'External: Share on facebook.com',
					url: `http://www.facebook.com/share.php?u=${objectPagePathBase}/${objectID}&title=${title}`,
					icon: <FacebookSVG className={styles.socialItemIcon} />,
					siteName: 'Facebook',
				},
				{
					title: 'External: share on pinterest.com',
					url: `http://pinterest.com/pin/create/bookmarklet/?media=${thumbnail}&is_video=false&description=${title}`,
					icon: <PintrestSVG className={styles.socialItemIcon} />,
					siteName: 'Pinterest',
				},
				{
					title: 'External: share on x.com',
					url: `http://x.com/intent/tweet?url=${objectPagePathBase}/${objectID}&text=${title}`,
					icon: <XSVG className={styles.socialItemIcon} />,
					siteName: 'X',
				},
				{
					title: null,
					url: `mailto:?subject=${title}&body=${title} from The Metropolitan Museum of Art %0A ${objectPagePathBase}/${objectID}`,
					icon: <MailSVG className={styles.socialItemIcon} />,
					siteName: 'Email',
				},
			].map((socialLink) => {
				return (
					<li key={socialLink.siteName} className={styles.socialItem}>
						<IconButton
							lightMode={true}
							label={socialLink.title}
							small={true}
							onClick={() => window.open(socialLink.url, '_blank')}
							className={styles.socialLink}
							icon={socialLink.icon}
							rel="noreferrer"
						/>
					</li>
				);
			})}
		</ul>
	);
};
export const SocialShare = (props: IProps) => {
	return (
		<ToolTip
			id={`object-${props.objectID}`}
			jsxDescription={<ShareLinks {...props} />}
		>
			<IconButton
				label="Share"
				lightMode={true}
				small={true}
				showLabel={false}
				icon={<ShareIcon />}
			/>
		</ToolTip>
	);
};

interface IProps {
	thumbnail: string;
	objectID: number | string;
	title: string;
}

export default SocialShare;
